<style src="./Radiobutton.scss" lang="scss"></style>

<template lang="pug">
  label.radiobutton
    input.radiobutton__input(
      type='radio'
      @change='onChange'
      v-model='fieldModel'
      :value='fieldValue'
      :name='name'
    )
    span.radiobutton__label {{ label }}
</template>

<script>
export default {
  props: {
    value: {
      default: "",
      type: String
    },
    fieldValue: {
      default: "",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    label: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      fieldModel: this.value
    };
  },
  watch: {
    value() {
      this.fieldModel = this.value;
    }
  },
  methods: {
    onChange() {
      this.$emit("input", this.fieldValue);
    }
  }
};
</script>
